/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.scheduler.controllers', [])

.controller('SchedulerController', ['$scope', function($scope) {

        $scope.scheduler = {

            init: function() {
                $scope.$emit('Application::contentTitleChange', {});
            }

        };

        $scope.scheduler.init();

}]);